import React from 'react';
import { Skeleton } from '@mui/material';
import TagListSkeleton from './TagListSkeleton';

function TagWidgetSkeleton() {
  return (
    <>
      <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
      <TagListSkeleton />
    </>
  );
}

export default TagWidgetSkeleton;
